module.exports = __webpack_public_path__ + "img/Sarawak.c27d8b51.png";